export interface Poetry {
  id: string;
  title: string;
  date: string;
  tags: string[];
  logo: string;
  content: string;
  excerpt?: string;
}

export const poetryPieces: Poetry[] = [
  {
    id: 'power-of-pen',
    title: 'Power of Pen',
    date: 'July 2, 2016',
    tags: ['Writing', 'Inspiration'],
    logo: '/images/poetry/pen-and-sward.png',
    excerpt: 'कलम तलवार से ज्यादा ताकतवर है - एक शक्तिशाली जवाब जो बताता है कि लेखनी कैसे एक हथियार बन सकती है',
    content: `"**The PEN is MIGHTIER than the SWORD**"  
— Edward Bulwer-Lytton | 1839

One day one of my friend asked me that "Why are you writing, why are you spending time with pen.  
You should spend that time in Gym for body building." I replied him with below lines  

ऐ शूरमा शमशीर पे इतना गुरूर न कर,  
हमने भी अपनी कलम में कई तूफनी जज्बे भर रखें हैं।  

हर एक फैसला तू जंग से ना कर,  
कई फैसले तो लेखनी ने अपनी नोक तले धर रखें हैं॥  

— बसंत कुमार वर्मा`
  },
  {
    id: 'kabhi-kabhi',
    title: 'कभी कभी',
    date: 'July 2, 2016',
    tags: ['Life', 'Moments'],
    logo: '/images/poetry/kabhi-kabhi.png',
    excerpt: 'तन्हाई में सुकून तलाशना, जब कोई सुनने को नहीं है तो अपने सारे गम तन्हाई से बाँटना',
    content: `कभी कभी तन्हाई से बातें किया करते है,  
तन्हाई में भी सुकून तलाश लिया करते हैं.  
दुनिया में फुर्सत किसे है किसीका दर्द सुनाने की,  
हम तो अपने सारे गम ऐसे ही बाँट लिया करते हैं.  


मिलता नहीं जब कन्धा कोई सर रख के रोने को,  
अश्कों की श्याही से कागज रंग दिया करते हैं.  
कुछ नाकाम सपने, कुछ हसरतें तो कुछ यादें हैं,  
जिन्हे लब्जो में पिरोया करते हैं.


कभी कभी तन्हाई से बातें किया करते है,  
भा गया हैं तन्हाई को भी साथ मेरा.  
अब तो वो भी पूछा करती हैं हाल मेरा,  
शायद वो भी तन्हा हैं बेचारी मेरी तरहां.  


रोज कहती हैं कल वापस जरूर आना देने साथ मेरा,  
वादा लेती है वापस लौट के आने का.  
अब बस यही हैं जो देती हैं हरपल साथ मेरा,  
कभी कभी तन्हाई से बातें किया करते है.  


कभी कभी तन्हाई से बातें किया करते है,  
हम तो अपने सारे गम ऐसे ही बाँट लिया करते हैं.  

— बसंत कुमार वर्मा`
  },
  {
    id: 'zindagi',
    title: 'ज़िन्दगी',
    date: 'July 2, 2016',
    tags: ['Life'],
    logo: '/images/poetry/zindagi.png',
    excerpt: 'ज़िन्दगी एक अनजान सफर है - ना पथ है, ना पथिक, ना मंजिल, फिर भी यह आगे बढ़ती जा रही है',
    content: `You must remember the famous bollywood song “ज़िन्दगी ऐक सफर है सुाहन, यहाँ कल क्या हो किसने जाना,”

I have tried to explain same kind of feeling in bellow lines

ऐक अनजान सफर सी यह ज़िन्दगी गुजरती जा रही है,  
उमंग हैं थमी पर धड़कन धड़कती जा रही हैं,  
चाह नई है बाकी अब इस दिल में कोई, फिर भी….  
अनजान चाह के पीछे-पीछे यह ज़िन्दगी चलती जा रही है,  

ना पथ है, ना पथिक, अनजान है मंजिल भी, फिर भी…  
ऐक अनजान सफर में यह ज़िन्दगी चलती जा रही है,  
हर पग, हर पथ पर सिर्फ दिलसे ही मिले है, फिर भी…  
बस एक और मौके की तलाश में इम्तेहान दिए जा रही है..  

इम्तेहान दिए जा रही है..चलती जा रही है..ज़िन्दगी..  
ऐक अनजान सफर सी ये ज़िन्दगी गुजरती जा रही है.  

— बसंत कुमार वर्मा`
  },
  {
    id: 'yeh-konsa-daur-hai',
    title: 'ये कोनसा दौर हैं ??',
    date: 'July 2, 2016',
    tags: ['Mix of Mood', 'Feelings', 'Emotions', 'Events'],
    logo: '/images/poetry/yeh-konsa-daur-hai.png',
    excerpt: 'इस दौर पर सवाल - उलझन, तन्हाई, रिश्ते, काम का तनाव, दिल टूटना, राजनीति और भ्रष्टाचार का मिला-जुला भाव',
    content: `A full mixture of mood…  

(When u are sitting lonely and thinking about something for a long and found NO CONCLUSION..!!!)  
**ना शांत हैं, ना शोर हैं,**  
**इक धुंध सी चारो ओर हैं,**  
**दिल में उठे सवालों का,**  
**यह कोनसा दौर हैं…..?**  

(When you think this is your happiest moments and few hours latter you realize that the moment was not as happiest as it can overcome the worst thing which just came to you…!!!)  
**कभी मधुबन में नाचता मोर हैं,**  
**कभी शांत से साहिल का कोई छोर हैं,** 
**बनते-बिखरते बुलबुलों का,**    
**यह कोनसा दौर हैं…..?**  

(When you need someone…don’t be panic, I mean someone who still in relationship with you..!! but not with you to hug you, hold you….but still you can feel the warmness of that hug could be.)  
**ना पास कोई, ना कोई दूर हैं,**  
**दूरियों के आगे हर कोई मजबूर हैं,**  
**फासलों में सिमटे रिश्तों का,**  
**यह कोनसा दौर हैं…..?**  

(You are tooooo busy in your work environment OR get bored with your daily schedule..hope something to be change….)  
**ज़िन्दगी तो आजकल जैसे कोई दौड़ हैं,**  
**अंजान पथ का, यह कोनसा मोड़ हैं,**  
**उमंगों में छुपी वीरानियों का,**  
**यह कोनसा दौर हैं…..?**  

(Something broken…something crying inside you… Mostly just after break-up)  
**दुनिया की भीड़ में, तन्हाइयों का शोर हैं,**  
**गुमनाम इस दुनियां में, अँधियारा हर इक ओर हैं,** 
**सन्नाटे में गूंजती पुकार का,** 
**यह कोनसा दौर हैं…..?**  

(Govt. System, Bloody Politics and their Vote bank theory…)
**भ्रष्ठ, कपट स्वार्थ ही चहुँ ओर हैं,**  
**सीने में लोगों की, दिल नहीं कुछ ओर हैं,** 
**निपट स्वार्थ की इस मलीन दुनिया का,** 
**यह कोनसा दौर हैं…..?**  

(No one can forget Delhi victims…)  
**अबला अस्मत के लुटेरे फैले हर इक ओर हैं,**  
**किसे पुकारे यहाँ, जब दिखता हर कोई चोर हैं,**  
**सत्ता, शाशन और बिगड़े परिवेश का,**  
**यह कोनसा दौर हैं…..?**  

(This bloody Corrupt System need to be changed….but it’s can’t be done by only ONE..)  
**मैं तो हूँ, पर नई हैं हम,**  
**आंख भी हैं थोड़ी नम,**  
**बस अपनी ही धड़कनो का शोर हैं,**  
**यह कोनसा दौर हैं…..?**  
**यह कोनसा दौर हैं…..?**  

— बसंत कुमार वर्मा`
  },
  {
    id: 'rishta',
    title: 'रिश्ता',
    date: 'November 25, 2013',
    tags: ['Relationship', 'Break-up'],
    logo: '/images/poetry/rishta.png',
    excerpt: 'कुछ लोग आजकल मसले नहीं सुलझाते, बल्कि रिश्ता ही सुलझा लेते हैं',
    content: `कुछ लोग आजकल प्रॉब्लम नहीं सुलझाते, बल्कि रिश्ता ही सुलझा लेते हैं  

सालों का रिश्ता, एक पल में छोड़ गए,  
दिल का कोई हिस्सा जैसे तोड़ गए।  
किसे कहें बेवफा, समझ नई आता,  
उसे जिसने रोका नई ??  
या उसे जो बिच रह में हाथ छोड़ गए।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'tu-hi-tu-hai',
    title: 'तू ही तू हैं',
    date: 'April 8, 2013',
    tags: ['You & Me', 'Us'],
    logo: '/images/poetry/tu-hi-tu-hai.png',
    excerpt: 'तू ही मेरी जमीन-आसमान है, तू ही मेरी सांस है, मेरे ख्वाब हैं, मेरा पूरा संसार',
    content: `तू हैं बस तू ही तू हैं,  
तेरा जादू और जुनूं है।  
मेरी जमी-आसमा तू है,  
हाँ तू है बस तू ही तू हैं।।  

सांसों में घुली तेरी खुशबू,  
तन्हाई पे भी तेरा पहरा।  
बातें तेरी लगे जैसे जादू,  
खोने लगा है दिल मेरा।।  

तुझे चाहता है अब ये ज्यादा,  
मेरा दिल है अब घर तेरा।  
तुझ बिन अब मैं हूँ आधा,  
कहने लगा है अब दिल मेरा।।  

संग-संग तेरे चलना चाहे,  
तुझको बाँहों में भरना चाहे।  
तेरी ही राह ताकता है,  
बावला ये दिल मेरा।।  

ख्यालों में मेरे बस तू है,  
यादों के साएं में भी तू है।  
आँखों को भाये सपने तेरे,  
हाँ तू है बस तू है।।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'sharab',
    title: 'शराब',
    date: 'January 17, 2013',
    tags: ['Drinks', 'Alcohol', 'Drinking'],
    logo: '/images/poetry/sharab.png',
    excerpt: 'जब वादे टूटते हैं और सपने चकनाचूर होते हैं, तो यह प्याला ही रंज-ओ-गम और उल्फत में साथी बन जाता है',
    content: `रंजो-गम में मदिरा के प्याले छलके,  
राज-ऐ-उल्फत में मैखाने महके।  
शराब को शौख कहो या बहाना यारो,  
ये जो ना हो तो सब रंग है फीके।।  

जब सनम के वादें झूंठे लगते है,  
जब सारे सपने टूटे-टूटे लगते हैं।  
साथ कोई दे ना पाए, साथ किसी का ना भाये,  
जाम उठा प्यारे, सब बेगाने अपने लगते हैं।।  

गम का साथी है ये अंगूरी प्याला,  
दर्द हो या उल्फत, दवा यह एक ही प्याला।  
जिंदगी की कशमकश में है जकड़ी साँसे,  
साँसे लगे आजाद जब लब चूमे ये प्याला।।  

इसे पीले, देख आजाद होक, तू जीके,  
मस्ती में झूमे, हो मदमस्त पिके।  
शौख कहो शराब को या बहाना, यारों  
ये जो ना हो सब रंग हैं फीखे।।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'yeh-barish-ki-bundae',
    title: 'ये बारिश की बूंदे',
    date: 'December 7, 2012',
    tags: ['Rain', 'Raindrops', 'Old Love'],
    logo: '/images/poetry/yeh-barish-ki-bundae.png',
    excerpt: 'ये बारिश की बूँदें आत्मा को छूती हैं, बचपन की यादें और एक पुरानी चाहत का दर्द वापस लाती हैं',
    content: `रिम-झिम कल-कल छम-छम करती, ये बारिश की बूँदें,  
तन को छूती मन को भाती, ये बारिश की बूँदें।  
दिल में हज़ारों उमंगें जगती, कुछ पुअरने एहसास कराती,  
बचपन के भूले बिसरे दिनों की याद दिलाती, ये बारिश की बूँदें।।  

कुछ भीगी, कुछ छलकी, कुछ मदमस्त कुछ महकी,  
वो सुहाने पलों की याद दिलाती, ये बारिश की बूँदें।  
छन-छन करती, झीर-मीर बरसी, विरहां की बदरी,  
तन्हाई का आभास कराती, ये बारिश की बूँदें।।  

कुछ ओझल से राज बतलाती, जाने पहचाने साज सुनती,  
एक पुरानी चाहत की याद दिलाती, ये बारिश की बूँदें।  
रकीब कह तो दूँ इन्हे, पर है रिपु सी फितरत इनकी,  
अपना बनाकर बेगानो की याद दिलाती, ये बारिश की बूँदें।।  

उस चाहत की याद दिलाकर, देखो कैसे थमी है जालिम, ये बारिश की बूँदें,  
बिन छुए, बिन भीगे, खुद रोकर अब लगी है देखो मुझे रुलाने, ये बारिश की बूँदें।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'pyar',
    title: '❤️💖💕',
    date: 'March 26, 2012',
    tags: ['Love', 'Emotional', 'Heartbreak'],
    logo: '/images/poetry/pyar.png',
    excerpt: 'क्यूँ कहते हैं प्यार पाक और सुहाना है, जब सच्चे आशिक़ तो बस आंसू और दिल टूटने का सामना करते हैं?',
    content: `क्यूँ कहते है सब के प्यार पाक और सुहाना है,  
हर किसी को गिरके इसमें बस जलना और मर जाना है।  
तड़प है, आंसूं है, रंज-ओ-गम का है दरिया यह,  
क्यूँ कहते है सब के यह एक मंजर सुहाना है।।  

रोना है हर सच्चे आशिक़ की किस्मत बस,  
बस रोते तड़पते ही उसे बिन सनम के मर जाना है ।  
दिल में बसने वाला ही आंसू देता है इसमें,  
कातिल है वो तो क्यूँ उस कातिल को दिल में बसना है।।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'aankehn-nahin-soti',
    title: 'आँखें नहीं सोती',
    date: 'March 22, 2012',
    tags: ['Sleepy', 'Busy', 'Missing'],
    logo: '/images/poetry/aankehn-nahin-soti.png',
    excerpt: 'तारे डूब गए, रात ढल रही है, पर आँखें नहीं सोती - कहने को बहुत कुछ है, पर बातें नहीं होती',
    content: `तारे डूब गए, रात ढलने को है, पर आँखें नहीं सोती,  
सुनाने-सुनाने को है बहोत कुछ बाकी, पर बातें नहीं होती।  
अब क्या बताएं कैसे कटती है ज़िन्दगी आजकल,  
धड़कन और साँसें है चलती, पर मन में कोई उमंग नहीं होती।।  

तारे डूब गए, रात ढलने को है, पर आँखें नहीं सोती,  

यह टिक-टिक करती घड़ियाँ, हमसे हैं कुछ कहती,  
वक़्त का पहरा है पल-पल पे, हर सांस है इनमे जकड़ी।  
रिश्ते नहीं बदले, इंसान नहीं बदले, पर ना जाने क्यूँ,  
आजकल उनसे मुलाकातों में वो पहले सी मिठास नहीं होती।।  

तारे डूब गए, रात ढलने को है, पर आँखें नहीं सोती,  
सुनाने-सुनाने को है बहोत कुछ बाकी, पर बातें नहीं होती।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'waqt-hi-nahin-milta',
    title: 'वक़्त ही नहीं मिलता',
    date: 'March 20, 2012',
    tags: ['Time', 'Busy', 'Life'],
    logo: '/images/poetry/waqt-hi-nahin-milta.png',
    excerpt: 'ज़िन्दगी अजीब हो गई है इन दिनों - वक़्त है फिर भी वक़्त ही नहीं मिलता अपनों को खुश करने या दोस्तों से मिलने का',
    content: `अजीब हो चली है जिंदगी इन दिनों, वक़्त है फिर भी वक़्त ही नहीं मिलता,  
जीते है अपनो के लिए ही पर, उन्हें मानाने को वक़्त ही नहीं मिलता।  
दफ्तर के माहौल में मशगूल है जिंदगानी इतनी की, अब लगता है जैसे,  
पैसे कमाने की दौड़ में शामिल है पर, खुशियां बटोरने को वक़्त ही नहीं मिलता।।  

कमी नहीं है वक़्त की किसी के पास भी, पर फिर भी ना जाने क्यों वक़्त ही नहीं मिलता,  
रेत के जर्रे सा गुजरता है वक़्त हाथ से, थामने को हाथ तक नहीं बढ़ता।  
दोस्तों से ही चलती थी दुनिया अपनी, दुनिया ही अपनी तो दोस्त ही है, पर ऐ दोस्त  
अजीज दोस्त सारे खफा बैठें हैं, और हम हैं की उन्हें मनाने का भी वक़्त ही नहीं मिलता।।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'wo-kitabe-aband-radde-mein-tabdeel-hain',
    title: 'वो किताबें अब रद्दी में तब्दील हैं !',
    date: 'February 7, 2012',
    tags: ['Books', 'Study', 'Manturity'],
    logo: '/images/poetry/wo-kitabe-aband-radde-mein-tabdeel-hain.png',
    excerpt: 'वो किताबें जिन्हें कभी सिरहाने रखकर सोते थे, आज रद्दी में तब्दील हैं - वो किताबें जिन्होंने हमें आज का इंसान बनाया',
    content: `वो किताबें अब रद्दी में तब्दील हैं, जिन्हे कभी सिरहाने रख कर सोया करते थे,  
कभी ना सोचा थे उनकी हालत ये होगी, जिनके कारन हर साल पास हुवा करते थे।  
दुनिया वाले सच ही कहा करते हैं, भूल जाते हैं सब जब अपना मतलब निकला जाया करते हैं,  
वो किताबें अब धूल चाटती नजर आती है, जिन्हे हम कभी जिल्द चढ़ाया करते थे।।  

उस किताब के पन्नो में अब चने खाते हैं, जिनमे चने उगने की विधि पढ़ा करते थे,  
वो पन्ने आज धूल साफ़ करते नजर आते हैं, जो कभी हमारा भविष्य बनाया करते थे।  
ये कुंजी थी विज्ञान की, ये गणित की अभ्यास पुस्तक और इससे हम व्याकरण पढ़ा करते थे,  
वो किताबें अब रद्दी में तब्दील हैं, जिनको खरीदने की खातिर पापा दिन-रात काम किया करते थे।।  

वो किताबें अब जाने कहाँ ग़ुम हैं, जिन्हे सालों तक कंधो पे धोया करते थे,  
आज वो बास्ते नजर नहीं आते हैं, जिनमे हम अपना सारा जहाँ समेट लिया करते थे।  
सब जरुरति चीजे होती थी उसमे, और तब जरूरतें भी कुछ काम हुवा करती थी,  
बचपन की वो अमीरी ना जाने कहाँ खो गई, जब बारिश के पानी में हमारे भी जहाज़ तेरा करते थे  

वो किताबें अब रद्दी में तब्दील है, जिनकी हम तब क़दर किया करते थे,  
वो किताबें अब रद्दी में तब्दील है, जिन्हे पढ़कर ही आज हमे रोजगार मिलें।  
वो किताबें अब रद्दी में तब्दील है, जिनको गिराने पे माथे से लगाया करते थे,  
वो किताबें अब रद्दी में तब्दील है, जिनके कारन आज हम इंसान बने।।  

वो किताबें अब रद्दी में तब्दील हैं, जिन्हे कभी सिरहाने रख कर सोया करते थे,  
वो किताबें अब जाने कहाँ ग़ुम हैं, जिन्हे सालों तक कंधो पे धोया करते थे।  
वो किताबें अब रद्दी में तब्दील है, जिनकी हम तब क़दर किया करते थे,  
वो किताबें अब रद्दी में तब्दील हैं, जिनको खरीदने की खातिर पापा दिन-रात काम किया करते थे,  
जिनको खरीदने की खातिर पापा दिन-रात काम किया करते थे।।  

— बसंत कुमार वर्मा`
  },
  {
    id: 'swatantra-hai-gantantra-ka-paradhin-yahan',
    title: 'स्वतंत्र हैं गणतंत्र का पराधीन यहाँ',
    date: 'January 25, 2011',
    tags: ['Freedom', 'Politics', 'Thoughts'],
    logo: '/images/poetry/swatantra-hai-gantantra-ka-paradhin-yahan.png',
    excerpt: 'सच्ची आज़ादी और लोकतंत्र पर सवाल - क्या हम सच में स्वतंत्र हैं या बस गणतंत्र के पराधीन?',
    content: `First of all I am sorry if I am spoiling your patriotic spirit…  

I wrote what I thought, I don’t know what you think….but it’s true..it is the real situation in India  

I started writing this one since 15th Aug, 2010, that day I only wrote it’s title and today (25th Jan, 2011) I completed it…  

Hope you agree with my thoughts…  

स्वतंत्र हैं गणतंत्र का पराधीन यहाँ,  
कोंन कहता है के “हैं हम स्वतंत्र” यहाँ |  
गर गणतंत्र का दमन चक्र ऐसे ही चलता रहा,  
तो बताओ क्या है स्वतंत्रता का मतलब यहाँ ||  

आज खुद से ही यह सवाल पूंछ हैं सब खामोश यहाँ,  
शायद बस विचार ही हैं अब स्वतंत्र यहाँ |  
क्या कहूँ आज के इस भारत को,  
स्वतन्त्र या फिर हैं सिर्फ गणतंत्र यहाँ ||  

जन साशन का अर्थ हैं, जन शोषण यहाँ,  
सत्ता बनी हैं सिर्फ टकसाल यहाँ |  
इस दिन को कैसे मनाऊं क्या नाम दूँ,  
गणतंत्र दिवस…….???  
या स्वतंत्रता की पुन्यातिथी कहना हैं शायद सार्थक यहाँ ||  

********** Lines are added latter after Delhi Nirbhaya Kand **********  
देख अस्मत लुटती अबला की, रहते है सब मोन यहाँ ।  
सीश जवानों के कटाके, शोक तक ना जताती सरकार यहाँ ।।  
दुर्योधन , दुशासन और शकुनी जैसे है आजाद और ध्रितारास्त्र है गणतंत्र यहाँ ।  
स्वतंत्र हैं गणतंत्र का पराधीन यहाँ, कोंन कहता है के “हैं हम स्वतंत्र” यहाँ ||  
********** Lines are added latter after Delhi Nirbhaya Kand **********  

स्वतंत्र हैं गणतंत्र का पराधीन यहाँ,  
कोंन कहता है के “हैं हम स्वतंत्र” यहाँ |  
स्वतंत्र हैं गणतंत्र का पराधीन यहाँ,  
कोंन कहता है के “हैं हम स्वतंत्र” यहाँ ||  

— बसंत कुमार वर्मा`
  },
  {
    id: 'ayodhya-kand',
    title: 'अयोध्या-कांड',
    date: 'September 23, 2010',
    tags: ['Religion', 'Politics', 'Thoughts'],
    logo: '/images/poetry/ayodhya-kand.png',
    excerpt: 'मंदिर-मस्जिद की लड़ाई के बजाय क्यों न सभी धर्मों के लिए स्कूल बनाएं जहाँ साथ-साथ प्रगति हो?',
    content: `First of all I am sorry to all those people who got hurt by this one…..I am really sorry

Here I am sharing only those old lines which came in my mind when I was a 12 years old little kid.

Generally I don’t use to share my own written lines on public place but today I thought that, It is the time I must have to share. The reason why I am sharing is that why this thing is still untouched by all those brilliant minds who always ready to fight on “Ayodhya Mandir-Masjid Mudda”

I don’t think it is a big issue as compared to corruption, starving, global warming and lots more.

When we have such giant issues which impacting our nature, our children’s future but we are fighting together on these “Hindu-Musalim Muddaa’s”

Here are few lines which I want to share and trying to open our politician’s eyes, more of that people’s eyes who execute politician’s plans

मंदिर हटाकर मस्ज़िद बनाते, 
मस्ज़िद हटाकर मंदिर।  
आपस में लड़ते रहते ये दोनों धर्म के भाई,  
फिर भी अपने आप को भारतीय कहलाते??  

अरे, भारतीय तो वो होते हैं,  
जो सभी धर्मो को भुलाभाई भाई की तरहां रहते हैं।  
मंदिर हटा दो मस्ज़िद हटा दो,  
वहां पर एक सुन्दर स्वछ विद्यालय बना दो॥  

जिसमे पढ़कर साक्षर हो हिन्दू-मुस्लिम-सिख-ईसाई,  
भारत को प्रगति के पथ पर लेके जाएँ ये चारो भाई।  
तब ना होंगे दंगे-फसाद, ना जाना होगा कोर्ट-कचेरी में,  
तब ना होगा अयोध्या-कांड इस पुरे कलयुग में॥. 

**Please think once…**

— बसंत कुमार वर्मा`
  },
  {
    id: 'love',
    title: 'Love',
    date: 'March 19, 2010',
    tags: ['Love', 'Relationship'],
    logo: '/images/poetry/love.png',
    excerpt: 'प्यार बस एक शब्द है जब तक कोई इसे मतलब न दे - पापा के लिए गुन्हा, आशिक़ों के लिए मजा, संतों के लिए पाक दुआ',
    content: `Love is Just a Word until you find someone to give it a Definition…

True I posted it so long ago, now updating with my finding till now

प्यार कोई **लफ्ज** नहीं,प्यार कोई **हर्फ़** नहीं,  
प्यार कोई **दवा** नहीं, प्यार कोई **मर्ज** नहीं,  

पापा की नज़रों में इससे बढ़कर कोई **गुन्हा** नहीं,  
आशिक़ों से पूछो तो इससे ज्यादा कहीं **मजा** नहीं,  

संतों की माने तो इससे पाक कोई **दुवा** नहीं,  
गर जो सुनलो पीर एक टूटे दिल की, तो दोस्त…  
इससे बढ़कर कोई **सजा** नहीं…  

— बसंत कुमार वर्मा`
  }
];

